/** @format */
import { utilityCreateIntlProvider } from '@/i18n/createProvider';
import { TLocale } from '@/utils/gatsby/types';

export const utilityCalculateBreadCrumbs = (
  path: string,
  locale: TLocale,
  listingUrl?: string,
  removeItem?: string | null,
) => {
  const { intl } = utilityCreateIntlProvider(locale);
  const splittedUrl = path.split('/');
  const urlHome = `/${locale}`;
  const urlItem: Array<string> = [urlHome];
  const list: Array<{ position: number; url: string; name: string; active: boolean }> = [
    {
      position: 0,
      url: `${urlHome}/`,
      name: 'home',
      active: false,
    },
  ];
  const splittedUrlFormatted = removeItem ? splittedUrl.filter(item => item !== removeItem.toLowerCase()) : splittedUrl;

  // eslint-disable-next-line no-plusplus
  for (let i = 2; i < splittedUrlFormatted.length - 1; i++) {
    const isRoomBreadcrumb = splittedUrlFormatted[i].includes(intl.formatMessage({ id: 'pdp_url_rent_part' }));
    const isActive = i === splittedUrlFormatted.length - 2;
    let formattedName = '';
    if (isRoomBreadcrumb && !!listingUrl) formattedName = listingUrl.replace(/_|-/g, ' ').replaceAll('/', '');
    else if (!!listingUrl && isActive) formattedName = splittedUrlFormatted[i - 1];
    else formattedName = splittedUrlFormatted[i].replace(/_|-/g, ' ');

    const formattedUrl = isRoomBreadcrumb && !!listingUrl ? listingUrl.replaceAll('/', '') : splittedUrlFormatted[i];

    urlItem.push(formattedUrl);
    list.push({
      position: i - 1,
      url: isActive ? path : `${urlItem.join('/')}/`,
      name: formattedName,
      active: isActive,
    });
  }

  return list;
};
